import { merge } from 'lodash-es'
import { createStore } from 'vuex'

import settings from './global/settings'
import modules from './modules/'

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */
const Store = createStore({
  modules,
  ...merge({}, settings),
  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEBUGGING,
})

export default Store
